import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalJobSplitter from "../../../../job-splitting/portal-job-splitter";

export default class JobFullDetailsToolsButtonsJobSplitter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      showJobScheduler: false,
    };
    this.handleJobSplitting = this.
    handleJobSplitting.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  handleJobSplitting(jobId) {
    let jobSplitterModal = $('#job-splitter-modal');
    jobSplitterModal.data('data-job-id', jobId);
    jobSplitterModal.modal('show');

    if (document.getElementById(
      'react-component-g4-logistics-portal-job-splitter'
    )) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(
          'react-component-g4-logistics-portal-job-splitter'
        )
      );
      ReactDOM.render(<PortalJobSplitter />,
        document.getElementById(
          'react-component-g4-logistics-portal-job-splitter'
        )
      );
    }
  }

  render() {
    return(
      <button className="btn btn-lg btn-primary"
              onClick={() => {
                this.handleJobSplitting(this.state.data.id)
              }}>
        <i className="fa fa-users"></i>&nbsp;
        Job Splitter
      </button>
    )
  }
}